import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Skeleton } from "primereact/skeleton";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CardSeplag from "../../../components/CardSeplag";
import { buscarParametroExercicio } from "../../../service/Monitora/Exercicio";
import { Link } from "react-router-dom";
import ModalMonitoraExercicios from "./modalMonitoraExercicios";
import style from "./style.module.css";

const MonitoraCadastroExercicios = () => {
  const [visibleModal, setVisibleModal] = useState(false);
  const [exercicios, setExercicios] = useState();
  const [exercicio, setExercicio] = useState([]);
  const [edit, setEdit] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [atualizaList, setAtualizaList] = useState(false);

  const count = useSelector((state) => state.counterRequestReducer.counterRequest);
  const isLoading = count > 0;

  useEffect(() => {
    buscarParametroExercicio().then((res) => {
      setExercicios(res.data);
    });

    if (atualizaList === true) {
      setAtualizaList(false);
    }
  }, [atualizaList]);

  const editExercicio = (_exercicio) => {
    setExercicio({ ..._exercicio });
    setEdit(true);
    setVisibleModal(true);
  };

  const showExercicio = (_exercicio) => {
    setExercicio({ ..._exercicio });
    setDisabled(true);
    setVisibleModal(true);
  };

  function handleShowModal() {
    setVisibleModal(true);
  }

  const buttonTable = (node, rowData) => {
    let editarExercicio;
    let vizualizarExercicio;

    editarExercicio = (
      <Button
        type="button"
        icon="pi pi-pencil"
        className="p-button-warning"
        style={{ marginRight: ".5em" }}
        onClick={() => editExercicio(node)}
        tooltip="Editar Exercício Orçamentário"
      ></Button>
    );
    if (rowData.flagAtivoMonitora !== "S") {
      vizualizarExercicio = (
        <Button
          type="button"
          icon="pi pi-eye p-button-icon"
          className="p-button p-component"
          onClick={() => showExercicio(node)}
          tooltip="Visualizar Exercício Orçamentário"
        ></Button>
      );
    }

    return (
      <div>
        {editarExercicio}
        {vizualizarExercicio}
      </div>
    );
  };

  const cicloBody = (node, rowData) => {
    if (node.cicloMonitoramento) {
      const idenExercicio = node.cicloMonitoramento.exercicio.idenExercicio;
      return (
        <Link to={`/exercicio/ciclo/${idenExercicio}`}>
          <Button
            type="button"
            icon="pi pi-sync"
            className="p-button p-component"
            tooltip="Consultar Ciclos Avaliativos"
          />
        </Link>
      );
    } else {
      const idenExercicio = node.exercicio.idenExercicio;
      return (
        <Link to={`/exercicio/ciclo/?idenExercicio=${idenExercicio}`}>
          <Button
            type="button"
            icon="pi pi-sync"
            className="p-button p-component"
            tooltip="Consultar Ciclos Avaliativos"
          />
        </Link>
      );
    }
  };

  const actionTemplate = (node, rowData) => {
    return buttonTable(node, rowData);
  };

  const habilitadoOrDesabilitado = (node) => {
    if (node.flagAtivoMonitora === "S") {
      return <div className={`${style["customer-badge"]} ${style["status-aprovado"]}`}>Sim</div>;
    } else {
      return <div className={`${style["customer-badge"]} ${style["status-inativo"]}`}>Não</div>;
    }
  };

  const header = (
    <div className="table-header">
      <Button
        type="button"
        onClick={() => {
          handleShowModal();
        }}
      >
        <span className="pi pi-check p-button-icon p-button-icon-left"></span>
        <span className="p-button-label">Habilitar Exercício</span>
      </Button>
    </div>
  );

  const TableLoader = (props) => {
    const products = Array.from({ length: 10 });
    const skeletonTemplate = () => {
      return <Skeleton></Skeleton>;
    };
    return (
      <CardSeplag title="“MONITORAMENTO: CONSULTA E/OU CADASTRO DE EXERCÍCIOS ORÇAMENTÁRIOS">
        <DataTable header={header} value={products} responsiveLayout="scroll" className="p-datatable-striped">
          <Column header="Exercício" body={skeletonTemplate} style={{ width: "15%" }}></Column>
          <Column header="Data Abertura" body={skeletonTemplate} style={{ width: "20%" }}></Column>
          <Column header="Data Fechamento" body={skeletonTemplate} style={{ width: "20%" }}></Column>
          <Column header="Ativo" body={skeletonTemplate} style={{ width: "20%" }}></Column>
          <Column header="Ação" body={skeletonTemplate} style={{ width: "25%" }}></Column>
        </DataTable>
      </CardSeplag>
    );
  };

  if (isLoading && !visibleModal) {
    return <TableLoader />;
  }

  return (
    <div className="datatable">
      <CardSeplag title="MONITORAMENTO: CONSULTA E/OU CADASTRO DE EXERCÍCIOS ORÇAMENTÁRIOS">
        <DataTable
          header={header}
          value={exercicios}
          stripedRows
          responsiveLayout="scroll"
          emptyMessage="Nenhum registro encontrado"
          sortField="exercicio.ano"
          sortOrder={-1}
        >
          <Column field="exercicio.ano" header="Exercício" style={{ width: "20%" }}></Column>
          <Column field="dataAbertura" header="Data Abertura" style={{ width: "20%" }}></Column>
          <Column field="dataFechamento" header="Data Fechamento" style={{ width: "20%" }}></Column>
          <Column
            field="flagAtivoMonitora"
            body={habilitadoOrDesabilitado}
            header="Ativo"
            style={{ width: "20%" }}
          ></Column>
          <Column body={cicloBody} header="Ciclos" style={{ width: "10%" }}></Column>
          <Column
            className="p-text-right"
            body={actionTemplate}
            field="action"
            header="Ação"
            style={{ width: "20%" }}
          ></Column>
        </DataTable>
        {visibleModal && (
          <ModalMonitoraExercicios
            edit={edit}
            disabled={disabled}
            exercicio={exercicio}
            visible={visibleModal}
            setVisible={setVisibleModal}
            setEdit={setEdit}
            setDisabled={setDisabled}
            setAtualizaList={setAtualizaList}
          />
        )}
      </CardSeplag>
    </div>
  );
};

export default MonitoraCadastroExercicios;
